'use client';
const getTextDecoration = (options)=>{
    const { underline, strikethrough } = options;
    const styles = [];
    if (underline) {
        styles.push('underline');
    }
    if (strikethrough) {
        styles.push('line-through');
    }
    return styles.length > 0 ? styles.join(' ') : 'none';
};

export { getTextDecoration };
//# sourceMappingURL=getTextDecoration.js.map
